import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');
  
  if (!token) {
    // Redirect to login if no token is found
    return <Navigate to="/" replace />;
  }
  
  // Render the protected component if authenticated
  return children;
};

export default ProtectedRoute;
